import { Component, inject } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { LoginFormComponent } from '@dges/forms/login-form';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'dges-login-dialog',
  templateUrl: './login-dialog.component.html',
  styleUrls: ['./login-dialog.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, LoginFormComponent, MatButton],
})
export class LoginDialogComponent {
  dialogRef = inject<MatDialogRef<LoginDialogComponent>>(MatDialogRef);

  form = new UntypedFormGroup({
    loginForm: new UntypedFormControl({
      emailFormControl: '',
      passwordFormControl: '',
    }),
  });

  login() {
    this.dialogRef.close(this.form.controls.loginForm.value);
  }

  cancel() {
    this.dialogRef.close();
  }
}
